// src/App.js
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import SignInPage from "./pages/SignInPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ErrorPage from "./pages/ErrorPage";
import AppRoutes from "./AppRoutes";
import ForgotPasswordToken from "./components/auth/ForgotPasswordEmail";
import PrivateRoute from "./components/auth/PrivateRoute";
import ResetPassword from "./pages/Admin Profile/ResetPassword";
import MaintenanceGuard from "./components/MaintenanceGuard";

// Rahul

function App() {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <BrandingProvider>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<SignInPage />} />
            <Route path="/admin-login" element={<SignInPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route
              path="/forgot-password-token/:token"
              element={<ForgotPasswordToken />}
            />

            {/* Private Routes */}
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <MaintenanceGuard panelType="master">
                    <AppRoutes />
                  </MaintenanceGuard>
                </PrivateRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  );
}

export default App;

